import { styled } from "@mui/material";

import { TruncatedText } from "@citrine/atoms/truncated-text";

export const Version = styled(TruncatedText)(({ theme }) => ({
  color: theme.palette.grey[400],
}));
